import React, { useEffect, useRef } from "react";
import ScrollReveal from "../../utils/ScrollReveal";
import HelmetWrapper from "../../components/sections/HelmetWrapper";
import { mainOlakeData } from "../../seo/metaDeta";
import { CiHeart, CiCircleCheck } from "react-icons/ci";
import { TbBrandLinktree } from "react-icons/tb";

const OlakeHome = () => {
  const childRef = useRef();

  useEffect(() => {
    childRef.current.init();
  }, []);

  return (
    <>
      <HelmetWrapper {...mainOlakeData} />
      <ScrollReveal
        ref={childRef}
        children={() => (
          <div className="olake-home-container">
            {/* Section 1: Apache Iceberg Transition */}
            <section className="iceberg-transition-section">
              <div className="section-content">
                <div className="company-name">
                  <img
                    src={require("../../assets/images/datazip-text-logo.svg")}
                    alt="Datazip"
                  />
                </div>
                <h2>
                  <span className="thin">Engineering</span>{" "}
                  <span className="highlight">your</span> <br /> transition to{" "}
                  <br />
                  <span className="blur-text">Apache Iceberg</span>
                </h2>
                <button className="iceberg-native-button">
                  <img
                    src={require("../../assets/images/iceberg-logo.svg")}
                    alt="Iceberg"
                    className="iceberg-native-icon"
                  />
                  Apache Iceberg Native
                </button>
              </div>

              <div className="trust-indicators">
                <div className="indicator">
                  <CiHeart />
                  <span>Composable Lake House Platform</span>
                </div>
                <div className="indicator">
                  <CiCircleCheck />
                  <span>Trusted by Data First Companies</span>
                </div>
                <div className="indicator">
                  <TbBrandLinktree />
                  <span>Multi-Platform Support</span>
                </div>
                {/* Mobile view single text */}
                <div className="mobile-scroll-text">
                  <div className="scroll-item">
                    <CiHeart />
                    <span>Composable Lake House Platform</span>
                  </div>
                  <div className="scroll-divider">•</div>
                  <div className="scroll-item">
                    <CiCircleCheck />
                    <span>Trusted by Data First Companies</span>
                  </div>
                  <div className="scroll-divider">•</div>
                  <div className="scroll-item">
                    <TbBrandLinktree />
                    <span>Multi-Platform Support</span>
                  </div>
                  <div className="scroll-divider">•</div>
                  <div className="scroll-item">
                    <CiHeart />
                    <span>Composable Lake House Platform</span>
                  </div>
                  <div className="scroll-divider">•</div>
                  <div className="scroll-item">
                    <CiCircleCheck />
                    <span>Trusted by Data First Companies</span>
                  </div>
                  <div className="scroll-divider">•</div>
                  <div className="scroll-item">
                    <TbBrandLinktree />
                    <span>Multi-Platform Support</span>
                  </div>
                  <div className="scroll-divider">•</div>
                </div>
              </div>
            </section>

            {/* Section 2: Data Replication */}
            <section className="data-replication-section">
              <div className="section-content">
                <div className="text-content">
                  <div className="olake-github-container">
                    <h4 className="olake-replication-title">OLake</h4>
                    <div
                      className="open-source-link show-on-mobile"
                      onClick={() =>
                        window.open(
                          "https://github.com/datazip-inc/olake",
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                    >
                      <img
                        src={require("../../assets/images/github.svg")}
                        alt="github"
                      />
                      Open Source/ Github
                    </div>
                  </div>
                  <h2>
                    <span className="thin">Replicate</span>{" "}
                    <span>your data </span>
                    <br />
                    in minutes.
                  </h2>
                  <p>Get the fastest real-time data replication with OLake.</p>
                  <div className="know-more-container">
                    <button
                      className="know-more"
                      onClick={() =>
                        window.open(
                          "https://olake.io/",
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                    >
                      Know more
                    </button>
                    <div
                      className="open-source-link hide-on-mobile"
                      onClick={() =>
                        window.open(
                          "https://github.com/datazip-inc/olake",
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                    >
                      <img
                        src={require("../../assets/images/github.svg")}
                        alt="github"
                      />
                      Open Source/ Github
                    </div>
                  </div>
                  <div className="metrics metrics-desktop">
                    <div className="metric">
                      <h3>50X</h3>
                      <p>Faster than traditional tools</p>
                    </div>
                    <div className="metric-divider"></div>
                    <div className="metric">
                      <h3>90%</h3>
                      <p>Cost savings with OSS</p>
                    </div>
                    <img
                      src={require("../../assets/images/stepper.svg")}
                      alt="stepper"
                      className="olake-stepper"
                    />
                  </div>
                  <div className="metrics metrics-mobile">
                    <div className="metric">
                      <h3>50X</h3>
                      <p>Faster than traditional tools</p>
                    </div>
                    <div className="metric">
                      <h3>90%</h3>
                      <p>Cost savings with OSS</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Section 3: Observability */}
            <section className="observability-section">
              <div className="section-content">
                <div className="coming-soon">AILake is coming soon</div>
                <h2>
                  <span className="thin"> Migrate to Iceberg</span> &nbsp; In
                  Days, Not Months
                </h2>
                <p>
                  We’re onboarding early partners for a limited-capacity early
                  access program.
                </p>
                <div className="cta-buttons">
                  <div className="getting-soon hide-on-mobile">Coming Soon</div>
                  <button
                    className="know-more"
                    onClick={() =>
                      window.open(
                        "https://olake.io/ai-lake",
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  >
                    Know more
                  </button>
                </div>
              </div>
            </section>
          </div>
        )}
      />
    </>
  );
};

export default OlakeHome;
